import { Component, Inject } from '@angular/core';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { UserGroupService } from '../crud-service';
import { ToastService } from 'src/app/shared/services/toast/toast.service';
import { MediaObserver } from '@angular/flex-layout';
import { TypeIndexEnum } from 'src/app/domain/registration/enums/type-index.enum';
import { UserGroupCrudIndex } from './crud-index';
import { Router } from '@angular/router';
import { UserService } from '../../users/crud.service';

@Component({
  selector: 'app-product-category-select-index',
  templateUrl: './crud-index-select.component.html',
  styleUrls: ['./crud-index.component.sass'],
  providers: [UserGroupService],
})
export class UserGroupIndexSelectComponent extends UserGroupCrudIndex {
  override title: string = 'SELECIONE UM TIPO DE USUÁRIO';
  override COLUMNS_TO_SHOW_WEB = [
    'type',
    'name'
  ];

  constructor(
    override dialog: MatDialog,
    override service: UserGroupService,
    override toastService: ToastService,
    override mediaObserver: MediaObserver,
    public dialogRefSelect: MatDialogRef<UserGroupIndexSelectComponent>,
    override usersService: UserService,
    override router: Router,
    @Inject(MAT_DIALOG_DATA)
    data: {
      type: TypeIndexEnum;
      select: boolean;
    }
  ) {
    super(dialog, service, toastService, mediaObserver, usersService, router);
    this.dataSelect = data;
  }

  ngOnInit(): void {}

  onCancel() {
    this.dialogRefSelect.close();
  }

  onSelect(data: any) {
    this.dialogRefSelect.close(data?.row);
  }
}
